// Unpublished Work © 2026 Deere & Company.

export function getLocationOrigin(): string {
    return window.location.origin;
}

export function getLocationPathname(): string {
    return window.location.pathname;
}

export function getLocationHostname(): string {
    return window.location.hostname;
}
